import { IS_DEV } from "@/data/constants";
import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export const SUPPORTED_LANGS: { [key: string]: string } = {
  en: "English",
  pt: "Portuguese",
};

export const DEFAULT_LANG = "en";

/** Narrows any locale to one we ship, so an unsupported `?lang=xx` can't leak downstream. */
export const toSupportedLang = (locale?: string | null): string => {
  const normalized = locale?.toLowerCase();
  return normalized && SUPPORTED_LANGS[normalized] ? normalized : DEFAULT_LANG;
};

i18n
  .use(HttpApi)
  // React bindings as a plugin.
  .use(initReactI18next)
  // Initialize
  .init({
    // Config options
    ns: ["translation", "bnpl", "start-trial-now"],
    defaultNS: "translation",

    // default language (locale)
    lng: DEFAULT_LANG,

    // Fallback
    fallbackLng: DEFAULT_LANG,

    debug: IS_DEV ? true : false,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
